<template>
  <div class="footBar">
    <div class="wrap">
      <el-row class="top">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="left">
          <img src="../../assets/imgs/foot-logo.png" alt="" />
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="right">
          <div class="box">
            <div>中国 上海 上海枫林路305号 复旦大学护理学院</div>
            <div>邮政编码 : 200032 &ensp; 电话 : (021)64430093</div>
            <div>邮箱 : E-mail:ebn@fudan.edu.cn</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="bottom">Copyright © 复旦大学护理学院. All Rights Reserved.</div>
  </div>
</template>

<script>
export default {
  name: "MyComponent",
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
};
</script>

<style scoped lang='less'>
.footBar {
  width: 100%;
  background-color: #707070;
  // margin: 0 auto;
  position: relative;
  .wrap {
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    width: 1200px;
  }
  .top {
    .left {
      background-color: #707070;
      height: 200px;
      position: relative;
      img {
        box-sizing: border-box;
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .right {
      background-color: #707070;
      height: 200px;
      padding: 56px 0;
      text-align: center;
      color: #989898;
      position: relative;
      .box {
        width: 300px;
        text-align: left;
        display: inline-block;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .bottom {
    color: #989898;
    background-color: #373737;
    height: 65px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 1200px) {
  .footBar {
    .top {
      .left {
        height: 90px;
        line-height: 90px;
        img {
          padding: 0 20px;
        }
      }
      .right {
        height: 80px;
        padding: 0;
        text-align: center;
        .box {
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
        }
      }
    }
    .bottom {
      height: 50px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/Foot.vue